import { gql } from '@apollo/client';

export const GET_WAREHOUSE_PLANNING_ENTRY_CONFIG_BY_WAREHOUSE_ID = gql`
    query GetWarehousePlanningEntryConfigByWarehouseId($warehouseId: Long!) {
        config: getWarehousePlanningEntryConfigByWarehouseId(warehouseId: $warehouseId) {
            id
            warehouseId
            warehouseName
            entryNode
            entryNodeDescription
            isActive
            splitOrderConfig
            templateEditStartTime
            templateEditEndTime
            updatedAt
            warehouseCurrentTime
        }
    }
`;

export interface WarehousePlanningEntryConfigByWarehouseIdType {
    id: string;
    warehouseId: number;
    warehouseName?: string;
    entryNode: string;
    entryNodeDescription: string;
    isActive: boolean;
    splitOrderConfig: number[];
    templateEditStartTime?: string;
    templateEditEndTime?: string;
    updatedAt?: string;
    /** 仓库当前时间（服务器按仓库时区换算，ISO_LOCAL_DATE_TIME；时区缺失时为 null，前端降级设备时间） */
    warehouseCurrentTime?: string;
}

export interface GetWarehousePlanningEntryConfigByWarehouseIdResponse {
    config: WarehousePlanningEntryConfigByWarehouseIdType | null;
}

export interface GetWarehousePlanningEntryConfigByWarehouseIdVariables {
    warehouseId: number;
}